var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Arrow_2",
    d: "M2.42992 15.4385C1.84367 16.0238 1.84293 16.9736 2.42825 17.5598C3.01357 18.1461 3.96332 18.1468 4.54957 17.5615L2.42992 15.4385ZM18.0103 3.50118C18.0109 2.67276 17.3399 2.00065 16.5114 2L3.01144 1.98936C2.18301 1.98871 1.51091 2.65975 1.51026 3.48818C1.50961 4.3166 2.18065 4.98871 3.00908 4.98936L15.0091 4.99882L14.9996 16.9988C14.999 17.8272 15.67 18.4993 16.4984 18.5C17.3269 18.5006 17.999 17.8296 17.9996 17.0012L18.0103 3.50118ZM4.54957 17.5615L17.5701 4.5615L15.4504 2.4385L2.42992 15.4385L4.54957 17.5615Z",
    fill: "#090808"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/Arrow.6828facd0c66203baa199f77ea3bb2fc.svg";
export { ForwardRef as ReactComponent };